<ng-template #template>
  <div
    class="card-spacing"
    [ngClass]="[
      'col-lg-' + width,
      needpaddingLeft ? 'pr-lg-0' : 'p-lg-0',
      isZoom ? 'zoomed' : ''
    ]"
  >
    <div class="card h-100">
      <div class="card-body">
        <h2>{{ data?.title }}</h2>
        <a
          (click)="zoom()"
          class="zoom"
          *ngIf="data.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.title"
          href="javascript:void(0)"
          ><img src="img/magnifier.svg" width="20px" class="zoom-chart"
        /></a>
        <div style="display: block">
          <canvas
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [legend]="barChartLegend"
            [colors]="lineChartColors"
            [chartType]="barChartType"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
